<div class="tha-pill" (click)="stop($event)">
<div class="all-pillicon-wrapr">
  <!-- Due date -->
  <button class="tha-btn" pTooltip="Set due date" tooltipPosition="top" appendTo="body"
    (click)="setDueDate.emit($event)">
    <i class="ri-calendar-line"></i>
  </button>

  <!-- Progress -->
  <button class="tha-btn" pTooltip="Set progress" tooltipPosition="top" appendTo="body"
    (click)="setProgress.emit($event)">
    <i class="ri-percent-line"></i>
  </button>

  <!-- Priority -->
  <button class="tha-btn" pTooltip="Set priority" tooltipPosition="top" appendTo="body"
    (click)="setPriority.emit($event)">
    <i class="ri-flag-line"></i>
  </button>

  <!-- Status -->
  <button class="tha-btn" pTooltip="Set status" tooltipPosition="top" appendTo="body"
    (click)="setStatus.emit($event)">
    <i class="ri-focus-3-line"></i>
  </button>

  <!-- Task group -->
  <button *ngIf="!isSubtask" class="tha-btn" pTooltip="Move group" tooltipPosition="top" appendTo="body"
    (click)="setGroup.emit($event)">
    <i class="ri-stack-line"></i>
  </button>

  <!-- Add tag -->
  <button class="tha-btn tha-btn--tag" pTooltip="Add tag" tooltipPosition="top" appendTo="body"
    (click)="addTag.emit($event)">
    <i class="ri-price-tag-3-line"></i>
  </button>

  <span class="tha-sep"></span>

  <!-- Timer: start -->
  <button class="tha-btn tha-btn--timer"
    *ngIf="!isTimerRunning && !isTimerPaused && isProjectMember"
    pTooltip="Start timer" tooltipPosition="top" appendTo="body"
    (click)="startTimer.emit()">
    <i class="ri-play-circle-line"></i>
  </button>

  <!-- Timer: pause -->
  <button class="tha-btn tha-btn--timer"
    *ngIf="isTimerRunning"
    [pTooltip]="'Pause · ' + formatTime(timerElapsed)" tooltipPosition="top" appendTo="body"
    (click)="pauseTimer.emit()">
    <i class="ri-pause-circle-line"></i>
  </button>

  <!-- Timer: resume -->
  <button class="tha-btn tha-btn--timer"
    *ngIf="isTimerPaused"
    [pTooltip]="'Resume · ' + formatTime(timerElapsed)" tooltipPosition="top" appendTo="body"
    (click)="resumeTimer.emit()">
    <i class="ri-play-circle-line"></i>
  </button>

  <!-- Log time -->
  <button class="tha-btn tha-btn--log" pTooltip="Log time" tooltipPosition="top" appendTo="body"
    (click)="logTime.emit()">
    <i class="ri-time-line"></i>
  </button>

  <!-- Copy link -->
  <button class="tha-btn" pTooltip="Copy link" tooltipPosition="top" appendTo="body"
    (click)="copyLink.emit()">
    <i class="ri-links-line"></i>
  </button>

  <span class="tha-sep"></span>

  <!-- Edit -->
  <button *ngIf="isEditAccess" class="tha-btn tha-btn--edit" pTooltip="Edit task" tooltipPosition="top" appendTo="body"
    (click)="editTask.emit()">
    <i class="ri-edit-box-line"></i>
  </button>

  <!-- Copy / Move (Super Admin, Developer, Admin) -->
  <button *ngIf="canCopyMove" class="tha-btn tha-btn--copymove" [pTooltip]="isSubtask ? 'Copy / Move subtask' : 'Copy / Move task'"
    tooltipPosition="top" appendTo="body" (click)="copyMove.emit()">
    <i class="ri-file-copy-2-line"></i>
  </button>

  <!-- Add subtask -->
  <button *ngIf="!isSubtask && isCreateAccess" class="tha-btn tha-btn--add" pTooltip="Add subtask" tooltipPosition="top" appendTo="body"
    (click)="addSubtask.emit()">
    <i class="ri-add-circle-line"></i>
  </button>

  <!-- Delete -->
  <button *ngIf="isDeleteAccess" class="tha-btn tha-btn--danger" [pTooltip]="isSubtask ? 'Delete subtask' : 'Delete task'" tooltipPosition="top" appendTo="body"
    (click)="deleteTask.emit()">
    <i class="ri-delete-bin-line"></i>
  </button>
</div>

  <button class="static-arrow"><i class="ri-arrow-left-s-line"></i></button>
</div>
